import React from 'react';


const Label = ({

   className = 'block text-sm font-medium mb-1 ', 
   htmlFor,
   label,
   ...rest // Capture any other props (e.g., onClick, form attributes)
}) => {

    return (
        <label
            htmlFor={htmlFor}
            className={className} // Combine base classes with any passed in className

            {...rest} // Pass any additional props
        >
            {label}
        </label>
    );
};

export default Label;